/* ============================================================
   PLUSHIE PATCH — help & story page interactions
   ============================================================ */
(function () {
  "use strict";
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    /* ---- FAQ: accordion ---- */
    window.ppFaqToggle = function (btn) {
      var item = btn.closest('.faq-item');
      if (item) item.classList.toggle('open');
    };

    /* ---- FAQ: category filter ---- */
    window.ppFaqCat = function (cat, btn) {
      document.querySelectorAll('.faq-cat').forEach(function (b) { b.classList.remove('on'); });
      if (btn) btn.classList.add('on');
      document.querySelectorAll('.faq-group').forEach(function (g) {
        g.style.display = (cat === 'all' || g.getAttribute('data-cat') === cat) ? '' : 'none';
      });
      // clear any active search when switching category
      var s = document.getElementById('faqSearch');
      if (s) s.value = '';
      checkEmpty();
    };

    /* ---- FAQ: live search ---- */
    window.ppFaqSearch = function (term) {
      term = (term || '').toLowerCase().trim();
      // reset category buttons to "All" visual when searching
      if (term) {
        document.querySelectorAll('.faq-cat').forEach(function (b, i) { b.classList.toggle('on', i === 0); });
        document.querySelectorAll('.faq-group').forEach(function (g) { g.style.display = ''; });
      }
      document.querySelectorAll('.faq-item').forEach(function (item) {
        var q = (item.querySelector('.faq-q span') || {}).textContent || '';
        var a = (item.querySelector('.faq-a') || {}).textContent || '';
        var match = !term || (q + ' ' + a).toLowerCase().indexOf(term) > -1;
        item.style.display = match ? '' : 'none';
      });
      // hide group titles with no visible items
      document.querySelectorAll('.faq-group').forEach(function (g) {
        var anyVisible = Array.prototype.some.call(g.querySelectorAll('.faq-item'), function (it) { return it.style.display !== 'none'; });
        var title = g.querySelector('.faq-group-title');
        if (title) title.style.display = anyVisible ? '' : 'none';
      });
      checkEmpty();
    };

    function checkEmpty() {
      var anyVisible = Array.prototype.some.call(document.querySelectorAll('.faq-item'), function (it) {
        return it.style.display !== 'none' && it.offsetParent !== null;
      });
      var empty = document.getElementById('faqEmpty');
      if (empty) empty.style.display = anyVisible ? 'none' : 'block';
      updateCount();
    }

    function updateCount() {
      var count = Array.prototype.filter.call(document.querySelectorAll('.faq-item'), function (it) {
        return it.style.display !== 'none';
      }).length;
      var el = document.getElementById('faqCount');
      if (el) el.textContent = count === 1 ? '1 question' : count + ' questions';
    }

    /* ---- FAQ: expand / collapse all ---- */
    window.ppFaqExpandAll = function (btn) {
      var items = document.querySelectorAll('.faq-item');
      var anyClosed = Array.prototype.some.call(items, function (it) { return !it.classList.contains('open'); });
      items.forEach(function (it) { it.classList.toggle('open', anyClosed); });
      if (btn) btn.textContent = anyClosed ? 'Collapse all' : 'Expand all';
    };

    updateCount();

    /* ---- About: scroll reveal ---- */
    var reveals = document.querySelectorAll('.chapter, .win, .human');
    if (reveals.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
        }, { threshold: 0.2 });
        reveals.forEach(function (el) { io.observe(el); });
      } else {
        reveals.forEach(function (el) { el.classList.add('in'); });
      }
    }
  }
})();
